import { createContext } from 'react';

export const BreakpointsContext = createContext(null);
BreakpointsContext.displayName = 'BreakpointsContext';
